<template>
  <section id="kz-home" class="c-2-bg">
    <div class="banner">
      <div class="banner-wrap">
        <img style="display: none;" src="./imgs/text.png" alt="">
        <h6>「 {{$t('kzhome.title')}} 」</h6>
        <p>{{$t('kzhome.desc')}}</p>
        <img style="display: inline-block!important;" src="https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210707015428381.png" alt="">
      </div>
    </div>
    <div class="text-wrap c-2-bg">
      <div class="text-1">
        <h6>What is slag coin (VDex)?</h6>
        <h5 class="b-1-cl">{{$t('kzhome.what')}}</h5>
        <p class="b-1-cl">{{$t('kzhome.whatA')}}</p>
      </div>
      <div class="text-2">
        <h6>VDex is not slag!</h6>
        <h5 class="b-1-cl">{{$t('kzhome.feature')}}</h5>
        <ul>
          <li>
            <img src="./imgs/icon1.png" alt="">
            <p class="b-1-cl">{{$t('kzhome.featureText1')}}</p>
            <p class="2p b-1-cl">{{$t('kzhome.featureText2')}}</p>
          </li>
          <li>
            <img src="./imgs/icon3.png" alt="">
            <p class="b-1-cl">{{$t('kzhome.featureText3')}}</p>
            <p class="2p b-1-cl">{{$t('kzhome.featureText4')}}</p>
          </li>
          <li>
            <img src="./imgs/icon4.png" alt="">
            <p class="b-1-cl">{{$t('kzhome.featureText5')}}</p>
            <p class="2p b-1-cl">{{$t('kzhome.featureText6')}}</p>
          </li>
        </ul>
      </div>
      <div class="text-3">
        <h6>Allocation ratio</h6>
        <h5 class="b-1-cl">{{$t('kzhome.title2')}}</h5>
        <div class="box a-3-bg">
          <div class="left">
            <div class="count">
              <span class="b-1-cl">{{$t('kzhome.totalText')}}</span>
              <p class="b-1-cl">{{$t('kzhome.total')}}</p>
            </div>
            <img src="./imgs/cir.png" alt="">
            <div class="bottom c-2-bg">
              <span class="b-1-cl">{{$t('kzhome.totalText2')}}</span>
              <p class="b-1-cl">{{$t('kzhome.total2')}}</p>
            </div>
          </div>
          <div class="right">
            <ul>
              <li class="b-1-cl">{{$t('kzhome.name')}}: <span>90%</span></li>
              <li class="b-1-cl">{{$t('kzhome.memberVip')}}: <span>5%</span></li>
              <li class="b-1-cl">{{$t('kzhome.knowName')}}: <span>5%</span></li>
            </ul>
            <p class="b-1-cl">{{$t('kzhome.falseText')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-link">
      <p class="target-text">{{$t('kzhome.target')}}</p>
      <p class="target-text-desc">{{$t('kzhome.solusion')}}</p>
    </div>
  </section>
</template>

<script>
import commonMixin from 'BlockChain-ui-privatization/PC/common-mixin/home/market/market';
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/home/market/international/international';
import 'BlockChain-ui-privatization/PC/common-mixin/home/market/market.styl';

export default {
  name: 'kz-home',
  mixins: [commonMixin, mixin],
  created() {
    this.init();
  },
  mounted() {
    const target = document.getElementById('kz-home');
    const { height } = target.getBoundingClientRect();
    let s;
    function resize() {
      s = window.screen.width / 2560;
      target.style.transformOrigin = '0 0';
      target.style.transform = `scale(${s},${s})`;
      target.style.width = `${window.innerWidth / s}px`;
      target.style.height = `${height * s}px`;
    }
    window.onresize = () => {
      resize();
    };
    resize();
  },
  methods: {
    linkTo() {
      window.location.href = 'www.baidu.com';
    },
  },
};
</script>

<style lang="stylus" scoped>
.banner {
  width: 100%;
  height: 484px;
  background: url('./imgs/banner_ch.png') no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-item: center;

  .banner-wrap {
    width: 100%;
    display: flex;
    justify-content: center;
    align-item: center;
    flex-direction: column;
  }

  img {
    width: 245px;
    // height: 51px;
    font-family: DINPro-Medium;
    font-size: 40px;
    color: #00F1DB;
    text-align: center;
    font-weight: 500;
    margin: 0 auto;
  }

  h6 {
    height: 71px;
    font-family: PingFangSC-Semibold;
    font-size: 50px;
    color: #00F1DB;
    letter-spacing: 1.04px;
    text-align: center;
    line-height: 71px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.50);
    font-weight: 600;
    margin-top: 20px;
  }

  p {
    height: 71px;
    font-family: DINPro-Bold;
    font-size: 36px;
    color: #FFFFFF;
    letter-spacing: 1.04px;
    text-align: center;
    line-height: 71px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.50);
    font-weight: 700;
  }
}

.text-wrap {

  h6 {
    font-family: DINPro-Medium;
    font-size: 20px;
    color: #00F1DB;
    text-align: center;
    margin-top: 120px;
  }
  h5 {
    margin-top: 16px;
    font-family: PingFangSC-Semibold;
    font-size: 36px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
  }
  .text-1 , .text-2, .text-3 {
    display: flex;
    align-items center;
    flex-direction column;
  }
  .text-1 {
    height: 508px;

    p {
      width: 872px;
      height: 132px;
      opacity: 0.8;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      line-height: 44px;
      word-break break-word;
      margin-top: 33px;
    }
  }
  .text-2 {
    height: 602px;

    ul {
      display flex;
      justify-content center;
      margin-top: 71px;

      &:last-child {
        margin-right: 0;
      }

      li {
        width: 327px;
        margin-right: 36px;
        text-align: center;

        img {
          width: 50px;
          height: 50px;
          margin-bottom: 36px;
        }

        p {
          width: 327px;
          word-break break-word;
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #FFFFFF;
          text-align: center;
          line-height: 42px;
        }

        .2p {
          margin-top: 0;
        }
      }
    }
  }
  .text-3 {
    height: 893px;

    .box {
      width: 1179px;
      height: 468px;
      background: #0B132F;
      border-radius: 10px;
      margin-top 80px;
      display flex;
      box-sizing border-box;

      .left {
        width: 300px;
        height: 300px;
        margin-top 68px;
        margin-left 51px;
        position: relative;
        .count {
          width: 109px;
          position: absolute;
          left: 96.5px;
          top: 120px;
          text-align: center;
          span {
            font-family: PingFangSC-Regular;
            font-size: 20px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
          }

          p {
            font-family: PingFangSC-Regular;
            font-size: 40px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            margin-top: 10px;
          }
        }
        img {
          width: 300px;
          height: 300px;
        }

        .bottom {
          width: 159px;
          height: 68px;
          line-height: 68px;
          background: #050B20;
          border: 1px solid #1669FF;
          box-shadow: 0 2px 6px 4px rgba(0,0,0,0.27);
          border-radius: 10px;
          border-radius: 10px;
          position: absolute;
          right: -100px;
          bottom: 0;
          text-align: center;
          font-family: DINPro-Medium;
          font-size: 16px;
          color: #fff;
          text-align: center;
          line-height: 22px;
          padding: 7px 0;
          box-sizing: border-box;
        }
      }

      .right {
        margin-left 253px;
        ul {
          width: 327px;
          height: 156px;
          margin-top: 111px;
          li {
            font-family: PingFangSC-Medium;
            font-size: 22px;
            color: #FFFFFF;
            line-height: 52px;
          }
        }

        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 30px;
          margin-top: 30px;
          width: 502px;
          word-break: break-word;
        }
      }
    }
  }
}

.footer-link {
  width: 100%;
  height: 374px;
  background-image: linear-gradient(270deg, #50E3C2 0%, #005FE0 100%);
  box-sizing: border-box;
  padding-top: 97px;
  text-align: center;

  .target-text {
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    color: #FFFFFF;
    text-align: center;
  }

  .target-text-desc {
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    margin-top: 28px;
  }

  .link {
    width: 240px;
    height: 50px;
    background: #050B20;
    box-shadow: 0 4px 12px 0 rgba(0,0,0,0.10);
    border-radius: 4px;
    border-radius: 4px;
    margin: 0 auto;
    margin-top: 50px;
    color: #FFF;
    font-size: 18px;
    img {
      width: 19.3px;
      height: 9.6px;
      margin-left: 75px;
      vertical-align middle;
    }
  }
}
</style>
